<template>
    <div class="competitor-config-card">
        <div class="competitor-header-row">
            <input-search class="competitor-action-search" @getData="getSearch" />
            <div class="competitor-actions-row">
                <div class="position-relative d-inline-flex">
                    <select
                        v-model="selectedConfigStatus"
                        class="btn btn-sm bg-white fw-400 select-like-btn"
                        @change="onConfigStatusChange"
                        style="padding:0 44px;min-width:180px;text-align:center;color:black!important;border:1px solid black!important"
                    >
                        <option value="">Todos</option>
                        <option value="normal">Normal</option>
                        <option value="por_configurar">Por configurar</option>
                        <option value="fuera_de_rango">Fuera de rango</option>
                    </select>
                    <img src="/icons/filter-recomendation.svg" alt="filter" class="icons-dark" style="position:absolute;left:10px;top:50%;transform:translateY(-50%);pointer-events:none" />
                </div>
                <div class="position-relative d-inline-flex">
                    <select
                        v-model="selectedCompetitor"
                        class="btn btn-sm bg-white fw-400 select-like-btn"
                        @change="onCompetitorChange"
                        style="padding:0 44px;min-width:180px;text-align:center;color:black!important;border:1px solid black!important"
                    >
                        <option value="">Todos</option>
                        <option v-for="comp in competitors" :key="comp.id" :value="comp.competitor_original_id">{{ comp.competitor_name }}</option>
                    </select>
                </div>
                <div class="position-relative d-inline-flex">
                    <select
                        v-model="selectedPositioning"
                        class="btn btn-sm bg-white fw-400 select-like-btn"
                        @change="onPositioningChange"
                        style="padding:0 44px;min-width:180px;text-align:center;color:black!important;border:1px solid black!important"
                    >
                        <option value="">Todos</option>
                        <option value="0">Por debajo</option>
                        <option value="1">Paridad</option>
                        <option value="2">Por encima</option>
                        <option value="3">Precio fijo</option>
                    </select>
                </div>
                <button 
                    class="btn btn-sm bg-white fw-400"
                    style="
                        color: black !important;  
                        border: 1px solid black !important
                    "
                    @click="viewConfig('','config-competitor-options','Configuración de competidor','Establece el posicionamiento y diferencial objetivo para varios productos de manera simultánea')"
                >
                    Configuración
                </button>
                <button 
                    class="btn fw-500 button-export text-white rounder-8 button-products d-flex align-items-center"
                    @click="exportDataFile"
                >
                    <img src="/icons/down.svg" alt="icono" class="me-1 icons">Exportar
                </button>
            </div>
        </div>

        <div class="competitor-table-info-row">
            <span 
                v-if="totalCount > 0 && !loading"
                class="competitor-total-count"
            >
                Total: {{ totalCount }}
            </span>
        </div>
        <div class="table-responsive border" v-if="products.length > 0 || loading">
            <placeholder v-if="loading" :type="'table'" :count="3"/>
            <table class="competitor-table w-100" v-else>
                <thead>
                    <tr>
                        <th v-if="isColumnVisible('product_sku')">{{ getColumnLabel('product_sku') }}</th>
                        <th v-if="isColumnVisible('product_name')">{{ getColumnLabel('product_name') }}</th>
                        <th v-if="isColumnVisible('product_unit_sale')">{{ getColumnLabel('product_unit_sale') }}</th>
                        <th v-if="isColumnVisible('value')" class="editable-header">{{ getColumnLabel('value') }}</th>
                        <th v-if="isColumnVisible('rule')" class="editable-header">{{ getColumnLabel('rule') }}</th>
                        <th v-if="isColumnVisible('codex_product_competitor')">{{ getColumnLabel('codex_product_competitor') }}</th>
                        <th v-if="isColumnVisible('competitor_name')">{{ getColumnLabel('competitor_name') }}</th>
                        <th v-if="isColumnVisible('competitor_status')">{{ getColumnLabel('competitor_status') }}</th>
                        <th v-if="isColumnVisible('date_last_manual_update')">{{ getColumnLabel('date_last_manual_update') }}</th>
                        <th v-if="isColumnVisible('actions')">{{ getColumnLabel('actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(product, index) in products" :key="index"
                    >
                        <td v-if="isColumnVisible('product_sku')">
                            <span class="competitor-sku-badge">{{ product.product_sku }}</span>
                        </td>
                        <td v-if="isColumnVisible('product_name')">{{ product.product_name }}</td>
                        <td v-if="isColumnVisible('product_unit_sale')">{{ formatMoney(product.product_unit_sale) }}</td>
                        <td v-if="isColumnVisible('value')" class="col-highlight">
                            {{ formatValue(product.value) }}
                        </td>
                        <td v-if="isColumnVisible('rule')" class="col-highlight">
                            <span class="competitor-position-label">{{ getPositionLabel(product.rule) }}</span>
                        </td>
                        <td v-if="isColumnVisible('codex_product_competitor')" class="competitor-competitor-cell">
                            <a
                                v-if="isCompetitorUrl(product.codex_product_competitor)"
                                :href="getCompetitorUrl(product.codex_product_competitor)"
                                :title="product.codex_product_competitor"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {{ product.codex_product_competitor }}
                            </a>
                            <span v-else>{{ product.codex_product_competitor || '—' }}</span>
                        </td>
                        <td v-if="isColumnVisible('competitor_name')" class="competitor-competitor-cell">{{ product.competitor_name || '—' }}</td>
                        <td v-if="isColumnVisible('competitor_status')">
                            <span :class="getCompetitorStatusBadgeClass(product.competitor_status)">
                                {{ getCompetitorStatusLabel(product.competitor_status) }}
                            </span>
                        </td>
                        <td v-if="isColumnVisible('date_last_manual_update')">
                            {{ formatDate(product.date_last_manual_update) === "—" ? formatDate(product.date_update) : formatDate(product.date_last_manual_update) }}
                        </td>
                        <td v-if="isColumnVisible('actions')">
                            <div class="d-flex flex-column gap-1">
                                <span
                                    @click="viewConfig(product,'config-competitor-update-one','Configuración de competidor','Establece el posicionamiento y diferencial objetivo para el producto seleccionado')"
                                >
                                    <img class="cursor-pointer" src="/icons/pencil-margin.svg" alt="Editar"/>
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- No data message -->
        <div v-if="products.length <= 0 && !loading" class="p-4 bg-white rounder-8 border border-1 text-center">
            <h4 class="fw-400 size-18 text-secondary">No existe información para mostrar</h4>
        </div>

        <PaginationControls
            v-if="totalCount > 0"
            :current-page="currentPage"
            :total-count="totalCount"
            :page-size="pageSize"
            @change-page="$emit('change-page', $event)"
            @change-page-size="$emit('change-page-size', $event)"
        />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import inputSearch from '@/components/inputSearch.vue';
import Placeholder from "../../../../../components/loadings/placeholder.vue";
import PaginationControls from "../../../../../components/PaginationControls.vue";
import configsRecTableMixin from '../mixins/configsRecTableMixin.js'

const POSITIONING_LABELS = {
    0: 'Por debajo',
    1: 'Paridad',
    2: 'Por encima',
    3: 'Precio fijo',
};

export default {
    name: 'table-competitor-config',
    mixins: [configsRecTableMixin],
    components: {
        inputSearch,
        Placeholder,
        PaginationControls
    },
    props: {
        products: {
            type: Array,
            required: true,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        totalCount: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 25
        }
    },
    data() {
        return {
            search_product: '',
            search_type: 'codigo',
            selectedConfigStatus: '',
            selectedCompetitor: '',
            selectedPositioning: '',
            competitors: [],
            tableConfigKey: 'competitor'
        }
    },
    computed: {
        ...mapGetters([
            "authentication_user",
            "activeDesk"
        ]),
    },
    mounted() {
        this.getCompetitors();
    },
    methods: {
        ...mapActions(["executeCommit", "get"]),
        getSearch(row) {
            this.search_product = row.search
            this.search_type = row.searchType
            this.$emit('getData', 
                this.search_product,
                this.search_type
            )
        },
        onConfigStatusChange() {
            this.$emit('filterConfigStatus', this.selectedConfigStatus);
        },
        onCompetitorChange() {
            this.$emit('filterCompetitor', this.selectedCompetitor);
        },
        onPositioningChange() {
            this.$emit('filterPositioning', this.selectedPositioning);
        },
        getCompetitors() {
            let url = `/api/pricescrapingcompetitors/`;
            if (!this.authentication_user.client_channel) {
                url = url + `?business=${this.authentication_user.client_business_select}`;
            }
            this.get({
                url: url
            }).then((response) => {
                this.competitors = response.results;
            });
        },
        formatMoney(value) {
            if (value === null || value === undefined) return '—';
            const formatted = new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(value);
            return `${this.authentication_user.client_money} ${formatted}`;
        },
        formatPercent(value) {
            if (value === null || value === undefined) return '—';
            const sign = value >= 0 ? '+' : '';
            return sign + value.toFixed(1) + '%';
        },
        getPositionLabel(value) {
            return POSITIONING_LABELS[value] || '—';
        },
        isCompetitorUrl(value) {
            return typeof value === 'string' && /^(https?:\/\/|www\.)\S+$/i.test(value.trim());
        },
        getCompetitorUrl(value) {
            const url = value.trim();
            return /^https?:\/\//i.test(url) ? url : `https://${url}`;
        },
        formatValue(value) {
            return new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 }).format(value * 100) + '%';
        },
        getDiffClass(product) {
            const diff = product.difference_percent;
            if (diff === null || diff === undefined) return '';
            if (diff > 5) return 'competitor-diff-warning';
            if (diff < -5) return 'competitor-diff-positive';
            return 'competitor-diff-neutral';
        },
        getStatusClass(product) {
            const status = product.competitor_status;
            if (status === 'ok' || status === 'cumple') return 'competitor-status-ok';
            if (status === 'review' || status === 'revisar') return 'competitor-status-review';
            return 'competitor-status-ok';
        },
        getStatusText(product) {
            const status = product.competitor_status;
            if (status === 'ok' || status === 'cumple') return '✓ Cumple';
            if (status === 'review' || status === 'revisar') return '△ Revisar';
            return '✓ Cumple';
        },
        getCompetitorStatusBadgeClass(status) {
            return {
                'competitor-status-badge': true,
                'margin-status-ok': status === 'normal',
                'margin-status-bajo': status === 'fuera_de_rango',
                'margin-status-default': !status || status === 'por_configurar',
            };
        },
        getCompetitorStatusLabel(status) {
            if (status === 'normal') return 'Normal';
            if (status === 'fuera_de_rango') return 'Fuera de rango';
            if (status === 'por_configurar') return 'Por configurar';
            return status || '—';
        },
        viewConfig(row, name, title, text) {
            this.$emit('viewModal', row, name, title, text);
        },
        exportDataFile() {
            this.executeCommit({ mutation: "loading_state_component" });
            let url = `/api/pricescrapingrules/export_config_competitor/`;
            if (!this.authentication_user.client_channel) {
                url = url + `?business=${this.authentication_user.client_business_select}`
            }
            this.get({
                url: url,
            }).then(() => {
                this.executeCommit({ mutation: "loading_state_component" });
                this.$notification.success(
                    "En un momento te llegará un correo electrónico con los datos de configuración de competidor exportados.",
                    { timer: 10, showCloseIcn: true }
                );
            });
        },
        formatDate(value) {
            if (value === null || value === undefined || value === '') return '—';

            // Opciones para forzar 2 dígitos en día y mes
            const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
            
            // Handle plain YYYY-MM-DD strings to avoid timezone shifts
            if (typeof value === 'string') {
                const iso = value.trim();
                const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/);
                if (m) {
                    const y = parseInt(m[1], 10);
                    const mo = parseInt(m[2], 10) - 1;
                    const d = parseInt(m[3], 10);
                    const dt = new Date(y, mo, d);
                    if (!isNaN(dt)) return dt.toLocaleDateString('es-PE', options).replaceAll('/', '-');
                }
            }
            const dt = new Date(value);
            if (isNaN(dt)) return '—';
            return dt.toLocaleDateString('es-PE', options).replaceAll('/', '-');
        },
    }
}
</script>

<style scoped>
.competitor-config-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 24px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.competitor-header-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 1.25rem;
}

.competitor-actions-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    flex-wrap: wrap;
    flex: 0 1 auto;
    max-width: 100%;
}

.competitor-actions-row .btn {
    height: 44.8px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
}

.competitor-table-info-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 0.5rem;
    margin-top: 0.25rem;
}

.competitor-total-count {
    font-size: 0.85rem;
    font-weight: 600;
    color: #6b7280;
    white-space: nowrap;
}

.competitor-action-search {
    flex: 1 1 250px;
    min-width: 0;
}

.competitor-action-search :deep(.search-container-wrapper),
.competitor-action-search ::v-deep .search-container-wrapper,
.competitor-action-search /deep/ .search-container-wrapper {
    width: 100%;
    max-width: none;
}

.competitor-action-search ::v-deep .search-wrapper,
.competitor-action-search /deep/ .search-wrapper {
    width: 100%;
}

@media (max-width: 767.98px) {
    .competitor-actions-row {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.5rem;
        width: 100%;
        align-items: stretch;
    }

    .competitor-actions-row > * {
        box-sizing: border-box;
        min-width: 0;
        width: 100%;
    }

    .competitor-actions-row .btn {
        width: 100%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
}

@media (max-width: 575.98px) {
    .competitor-actions-row {
        grid-template-columns: repeat(2, 1fr);
        gap: 0.4rem;
    }
}

/* Tabla */
.competitor-table {
    border-collapse: collapse;
    font-size: 0.85rem;
    min-width: 1100px;
}

.competitor-table thead th {
    text-align: left;
    font-size: 0.7rem;
    font-weight: 700;
    color: #9ca3af;
    letter-spacing: 0.03em;
    padding: 10px 12px;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
    background-color: #F3F4F6;
}

.competitor-table tbody td {
    padding: 12px;
    border-bottom: 1px solid #f3f4f6;
    vertical-align: middle;
    color: #1f2937;
    white-space: nowrap;
}

.competitor-table tbody tr:hover {
    background: #fafafa;
}

.competitor-sku-badge {
    display: inline-block;
    background: #f3f4f6;
    color: #374151;
    font-size: 0.78rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 6px;
}

.competitor-global-value {
    color: #9ca3af;
    font-size: 0.82rem;
}

.competitor-competitor-cell {
    color: #4b5563;
}

.competitor-competitor-cell a {
    display: inline-block;
    max-width: 230px;
    overflow: hidden;
    color: #2563eb;
    text-decoration: none;
    text-overflow: ellipsis;
    vertical-align: bottom;
    white-space: nowrap;
}

.competitor-competitor-cell a:hover {
    text-decoration: underline;
}

.competitor-position-label {
    font-size: 0.82rem;
    color: #374151;
}

.competitor-diff-positive {
    color: #2563eb;
    font-weight: 600;
}

.competitor-diff-neutral {
    color: #111827;
    font-weight: 600;
}

.competitor-diff-warning {
    color: #f59e0b;
    font-weight: 700;
}

.competitor-status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 700;
}

.competitor-status-ok {
    color: #065f46;
    background: #d1fae5;
}

.competitor-status-review {
    color: #c2410c;
    background: #ffedd5;
}

.competitor-status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 72px;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 0.78rem;
    font-weight: 700;
    line-height: 1;
    border: 1px solid transparent;
}

.margin-status-ok {
    color: #065f46;
    background: #d1fae5;
    border-color: #a7f3d0;
}

.margin-status-bajo {
    color: #991b1b;
    background: #fee2e2;
    border-color: #fecaca;
}

.margin-status-default {
    color: #6b7280;
    background: #f3f4f6;
    border-color: #e5e7eb;
}

.competitor-table thead th.editable-header {
    background-color: #E8F8F4;
    color: #087F6A;
    font-weight: 700;
}

.competitor-table tbody td.col-highlight {
    background-color: #F8FCFB;
}

.button-export {
    background-color: #021418;
}

.button-products {
    padding: 10.5px 20px !important;
}

.icons-dark {
    filter: brightness(0);
    width: 18px;
    height: 18px;
}

.icons {
    filter: brightness(0) invert(1);
    width: 20px;
    height: 20px;
}
</style>
